import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "./index";
import { Adjunto } from "./contexto/ClasesGrales";
import { clBasic } from "./general";
import PopupUsuarios from "./PopupUsuarios";
import CambiarFechas from "./CambiarFechas"
import CerrarVentana from "./CerrarVentana";

export default function MenuActividad({ elemento, ind, setRefresh, setChange }) {
  let { firebase } = useContext(AppContext);
  let actividad = firebase.proyectoActivo.actividades[ind];

  let menuAct = ["Asignar recursos", "Eliminar recurso", "Cambiar fechas", "Eliminar actividad", "Adjuntar archivo", "Ver adjunto", "Eliminar adjunto"];

  const [contexto, setContexto] = useState({ x: 0, y: 0 });
  const [contextoVisible, setContextoVisible] = useState(false);
  const [item, setItem] = useState("");
  const [adjunto, setAdjunto] = useState(new Adjunto());
  const menuactividad = elemento + "menuact";
  const contextmenuact = elemento + "ctxmenuact";
  const [imageAsFile, setImageAsFile] = useState(null);
  const [progress, setProgress] = useState("");
  const [blob, setBlob] = useState(null);
  const [open, setOpen] = useState(true)

  const ScampoSeleccion = {
    height: "25px",
    fontSize: "13px",
    listStyleType: "none",
    cursor: "pointer",
  };
  const Scontext = {
    color: clBasic,
    textAlign: "left",
    position: "fixed",
    top: `${contexto.y}px`,
    left: `${contexto.x}px`,
    zIndex: 7,
    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    borderRadius: "5px",
    padding: "10px",
    background: "white"
  };
  const Sadjuntar = {
    width: "280px",
    color: "white",
    position: "fixed",
    top: `${contexto.y}px`,
    left: `${contexto.x}px`,
    zIndex: 7,
    background: "#212121",
    border: "1px solid white",
    padding: "10px",
  };
  const Sver = {
    width: "1080px",
    height: "400px",
    color: "white",
    position: "fixed",
    top: "100px",
    left: "100px",
    zIndex: 7,
    background: "#212121",
    border: "1px solid white",
    padding: "10px",
  };
  const Seliminar = {
    width: "280px",
    color: "white",
    position: "fixed",
    top: `${contexto.y}px`,
    left: `${contexto.x}px`,
    zIndex: 7,
    background: "#212121",
    border: "1px solid white",
    padding: "10px",
  };

  function adjuntarArchivo() {
    return (
      <div style={Sadjuntar}>
        <input
          type="file"
          onChange={(e) => {
            e.persist();
            setImageAsFile(e.target.files[0]);
            setAdjunto(new Adjunto(actividad.proyecto + actividad.id + e.target.files[0].name, e.target.files[0].name, ""));
          }}
        />
        <button
          onClick={() => {
            actualizarAdjunto();
            setChange(true)
          }}
          style={{ borderRadius: "5px", background: "red", height: "15px" }}
        ></button>
        {progress}
      </div>
    );
  }

  function actualizarAdjunto() {
    // subirlo al storage y asociarlo a la actividad
    if (imageAsFile) {
      const uploadTask = firebase.storage.ref(`actividades/adjuntos/${adjunto.id}`).put(imageAsFile);

      uploadTask.on(
        "state_changed",
        (snapShot) => {
          var progress = (snapShot.bytesTransferred / snapShot.totalBytes) * 100;
          setProgress(progress);
          console.log("Upload de adjunto  " + progress + "% done");
        },
        (err) => {
          console.log("Error al cargar el adjunto", err);
        },
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
            adjunto.url = downloadURL;
            setItem("");
            actividad.files.push(adjunto);
            setRefresh((r) => !r);
          });
        }
      );
    }
  }

  function verArchivo() {
    bajarAdjunto();
    return (
      <div style={Sver}>
        <button onClick={() => setItem("")} style={{ borderRadius: "5px", background: "red", height: "15px" }}></button>
        {blob}
      </div>
    );
  }

  function bajarAdjunto() {
    let xhr = new XMLHttpRequest();
    xhr.responseType = "text";
    xhr.onload = function (event) {
      let blob = xhr.response;
      setBlob(blob);
    };
    xhr.open("GET", actividad.files[0].url);
    xhr.send();
  }

  function eliminarArchivo() {
    borrarAdjunto();
    return (
      <div style={Seliminar}>
        <button onClick={() => setItem("")} style={{ borderRadius: "5px", background: "red", height: "15px" }}></button>
        {"eliminado"}
      </div>
    );
  }

  function borrarAdjunto() {
    firebase.storage
      .ref(`actividades/adjuntos/${actividad.files[0].id}`)
      .delete()
      .catch((e) => console.log("error borrando archivo"));
    actividad.files.splice(0, 1);
  }

  function eliminarActividad() {
    if (actividad.estado !== "") {
      // se marca para baja logica
      firebase.proyectoActivo.addBajaLogica(actividad.id);
    }
    firebase.proyectoActivo.actividades.splice(ind, 1);
    setItem(null)
    setRefresh((r) => !r);
    setChange(true)
  }

  function eliminarRecurso() {
    actividad.asignados.splice(actividad.asignados.length - 1, 1);
    setItem(null)
    setRefresh((r) => !r);
    setChange(true)
  }

  function cambiarFechas() {
    return (
      <CambiarFechas ind={ind} x={contexto.x} y={contexto.y} setRefresh={setRefresh} setChange={setChange} setOpen={setOpen} />)
  }

  useEffect(
    () => {
      document.getElementById(elemento).addEventListener("contextmenu", (e) => {
        e.preventDefault();
        const clickX = e.clientX < 1200 ? e.clientX : 1200;
        const clickY = e.clientY < 500 ? e.clientY : 500;
        setContexto({ x: clickX, y: clickY });
        setContextoVisible(true);
      });
      document.getElementById(menuactividad).addEventListener("click", (e) => {
        if (e.target.id === contextmenuact)
          setContextoVisible(false)
      })
    },
    [contextmenuact, menuactividad, elemento]
  );

  function drop(e) {
    if (e.target.id === contextmenuact) {
      e.persist();
      setContexto((c) => ({ ...c, x: e.screenX - 50, y: e.screenY - 50 }));
    }
  }

  function menuActividad() {
    return (
      <div style={Scontext}>
        <CerrarVentana set={setContextoVisible} />

        <div
          id={contextmenuact}
          draggable="true"
          onDragEnd={(e) => drop(e)}
          onMouseEnter={(e) => {
            e.currentTarget.style.cursor = "cell";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.cursor = "";
          }}
        >
          {menuAct.map((item, i) => {
            return (
              <li
                style={ScampoSeleccion}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = clBasic;
                  e.currentTarget.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "white";
                  e.currentTarget.style.color = clBasic;
                }}
                key={i}
                onClick={(e) => {
                  setItem(item);
                  setContextoVisible(false);
                }}
              >
                {item}
              </li>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div id={menuactividad}>
      {contextoVisible ? menuActividad() : null}
      {item === "Adjuntar archivo" ? adjuntarArchivo() : null}
      {item === "Ver adjunto" ? verArchivo() : null}
      {item === "Eliminar adjunto" ? eliminarArchivo() : null}
      {item === "Asignar recursos" && open && <PopupUsuarios x={contexto.x} y={contexto.y} setOpen={setOpen} />}
      {item === "Eliminar recurso" ? eliminarRecurso() : null}
      {item === "Eliminar actividad" ? eliminarActividad() : null}
      {item === "Cambiar fechas" && open ? cambiarFechas() : null}
    </div>
  );
}
